"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDiagnosisSchema = exports.createDiagnosisSchema = exports.diagnosisShape = void 0;
const zod_1 = require("zod");
exports.diagnosisShape = {
    icdCode: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string().min(1).max(255),
    description: zod_1.z.string().optional(),
    parentCodeId: zod_1.z.string().uuid().optional(),
    isChronic: zod_1.z.boolean().default(false),
    isNotifiable: zod_1.z.boolean().default(false),
};
exports.createDiagnosisSchema = zod_1.z.object(exports.diagnosisShape);
exports.updateDiagnosisSchema = exports.createDiagnosisSchema.partial();
//# sourceMappingURL=diagnosis.schema.js.map